'use client';

import { useCallback, useMemo } from 'react';

import { generateLink } from '@/utils/formatters/generate-link';
import { removeNonNumericCharacters } from '@/utils/formatters/format-whatsapp';
import { scheduleDefaultWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';

export const useWhatsappLinkSimple = (
  phone: string,
  text = scheduleDefaultWhatsappMessage,
) => {
  const resolveLink = useCallback(
    (phoneVariant: string) =>
      generateLink({
        url: 'https://api.whatsapp.com/send',
        params: [
          { key: 'phone', value: `55${removeNonNumericCharacters(phoneVariant)}` },
          { key: 'text', value: text },
        ],
      }),
    [text],
  );

  const url = useMemo(
    () =>
      generateLink({
        url: 'https://api.whatsapp.com/send',
        params: [
          { key: 'phone', value: `55${removeNonNumericCharacters(phone)}` },
          { key: 'text', value: text },
        ],
      }),
    [phone, text],
  );

  return { url, resolveLink };
};
